import { Terminal, Mail } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const Footer = () => {
  return (
    <footer className="bg-card/80 border-t border-border/50 mt-16 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-2">
            <Terminal className="w-6 h-6 text-primary" />
            <span className="text-xl font-bold font-cyber text-primary">&lt;GameDev/&gt;</span>
          </div>
          
          <Separator className="my-6" />
          
          <div className="flex items-center justify-center gap-3 text-sm font-mono text-muted-foreground">
            <Mail className="w-4 h-4 text-primary" />
            <span>contact@gamedev.studio</span>
          </div>
          
          <p className="text-xs text-muted-foreground font-mono">
            © 2024 GameDev Studio. Indie Game Development.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;